import React from "react";
import KJMainScreen from "./kayJwellers/kjMain";
import PagodaMainScreen from "./PagodaNew/pagodaMain";
import ZalesMainScreen from "./ZalesComponents/zalesMain";
import CVSMain from "./CVSComponents/CVSMain";
import AllMainScreen from "./AllComponents/AllDataMain";
import VisualDemographicScreen from "./VisualDemographic/VisualDemographicMain"
import DeviceList from "./DeviceList/DeviceList";

export interface Customer {
  name: string;
  component: React.FC;
}

export const Customers: Customer[] = [
  {
    name: "All",
    component: AllMainScreen,
  },
  {
    name: "pagoda-cms-prod",
    component: PagodaMainScreen,
  },
  {
    name: "zales-cms-prod",
    component: ZalesMainScreen,
  },
  {
    name: "kay-jwellers-cms-prod",
    component: KJMainScreen,
  },
  {
    name: "cvs-vividplay",
    component: CVSMain,
  },
  {
    name: "visual-demographic",
    component: VisualDemographicScreen,
  },
  {
    name: "Device List",
    component: DeviceList,
  }
];
